// extracted by mini-css-extract-plugin
export default {"searchResultsContainer":"GlobalSearchResults_searchResultsContainer__5jOrN"};